import {Feature} from "./feature";

export class OrderFeature {
  count: number;
  value: string;
  feature: Feature;
}
